"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.General = void 0;
const config_1 = require("../../config");
const axes_1 = require("../webgl/components/axes");
const grid_1 = require("../webgl/components/grid");
const GeneralControls_1 = require("./components/GeneralControls");
class General {
    constructor(webgl) {
        this.generalFunctions = {
            toggleGrid: () => this.toggleGridHelper(),
            toggleAxes: () => this.toggleAxesHelper()
        };
        this.webgl = webgl;
        const gridConf = config_1.config.webgl.helpers.grid;
        this.gridHelper = (0, grid_1.createGridHelper)(this.webgl, gridConf.size, gridConf.division, gridConf.gridColor, gridConf.centerColor);
        this.axesHelper = (0, axes_1.createAxesHelper)(this.webgl, config_1.config.webgl.helpers.axes.size);
        const parentEl = document.getElementById('general');
        if (!parentEl) {
            throw new Error("Parent element (general) is undefined");
        }
        this.generalControls = new GeneralControls_1.GeneralControls(parentEl);
        this.addEvents();
    }
    get isGridHelperVisible() {
        var _a;
        return ((_a = this.gridHelper) === null || _a === void 0 ? void 0 : _a.visible) || false;
    }
    get isAxisHelperVisible() {
        var _a;
        return ((_a = this.axesHelper) === null || _a === void 0 ? void 0 : _a.visible) || false;
    }
    dispose() {
        var _a, _b;
        this.removeEvents();
        (_a = this.generalControls) === null || _a === void 0 ? void 0 : _a.dispose();
        (_b = this.axesHelper) === null || _b === void 0 ? void 0 : _b.dispose();
        delete this.generalControls;
        delete this.gridHelper;
        delete this.axesHelper;
        delete this.webgl;
    }
    hideGridHelper() {
        var _a;
        this.gridHelper.visible = false;
        (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.renderOnce();
    }
    hideAxisHelper() {
        var _a;
        this.axesHelper.visible = false;
        (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.renderOnce();
    }
    showGridHelper() {
        var _a;
        this.gridHelper.visible = true;
        (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.renderOnce();
    }
    showAxisHelper() {
        var _a;
        this.axesHelper.visible = true;
        (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.renderOnce();
    }
    addEvents() {
        var _a, _b, _c, _d;
        (_b = (_a = this.generalControls) === null || _a === void 0 ? void 0 : _a.gridBtn) === null || _b === void 0 ? void 0 : _b.setEvent('click', this.generalFunctions.toggleGrid);
        (_d = (_c = this.generalControls) === null || _c === void 0 ? void 0 : _c.axesBtn) === null || _d === void 0 ? void 0 : _d.setEvent('click', this.generalFunctions.toggleAxes);
    }
    removeEvents() {
        var _a, _b, _c, _d;
        (_b = (_a = this.generalControls) === null || _a === void 0 ? void 0 : _a.gridBtn) === null || _b === void 0 ? void 0 : _b.removeEvent('click', this.generalFunctions.toggleGrid);
        (_d = (_c = this.generalControls) === null || _c === void 0 ? void 0 : _c.axesBtn) === null || _d === void 0 ? void 0 : _d.removeEvent('click', this.generalFunctions.toggleAxes);
    }
    toggleGridHelper() {
        var _a, _b;
        if (this.gridHelper) {
            this.gridHelper.visible = !((_a = this.gridHelper) === null || _a === void 0 ? void 0 : _a.visible);
        }
        (_b = this.webgl) === null || _b === void 0 ? void 0 : _b.renderOnce();
    }
    toggleAxesHelper() {
        var _a;
        if (this.axesHelper) {
            this.axesHelper.visible = !this.axesHelper.visible;
        }
        (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.renderOnce();
    }
}
exports.General = General;
